const countryCodes = [
  { code: "+1", flag: "🇺🇸", label: "United States", startFormat: "", phoneLength: 10, phoneRegex: /^\d{10}$/ },
  { code: "+44", flag: "🇬🇧", label: "United Kingdom", startFormat: "7", phoneLength: 10, phoneRegex: /^7\d{9}$/ },
  { code: "+61", flag: "🇦🇺", label: "Australia", startFormat: "4", phoneLength: 9, phoneRegex: /^4\d{8}$/ },
  { code: "+63", flag: "🇵🇭", label: "Philippines", startFormat: "9", phoneLength: 10, phoneRegex: /^09\d{9}$/ },
  { code: "+65", flag: "🇸🇬", label: "Singapore", startFormat: "8", phoneLength: 8, phoneRegex: /^[89]\d{7}$/ },
  { code: "+91", flag: "🇮🇳", label: "India", startFormat: "9", phoneLength: 10, phoneRegex: /^[6-9]\d{9}$/ },
  { code: "+86", flag: "🇨🇳", label: "China", startFormat: "1", phoneLength: 11, phoneRegex: /^1\d{10}$/ },
  { code: "+82", flag: "🇰🇷", label: "South Korea", startFormat: "1", phoneLength: 10, phoneRegex: /^1\d{8,9}$/ },
  { code: "+62", flag: "🇮🇩", label: "Indonesia", startFormat: "8", phoneLength: 10, phoneRegex: /^8\d{8,10}$/ },
  { code: "+60", flag: "🇲🇾", label: "Malaysia", startFormat: "1", phoneLength: 10, phoneRegex: /^1\d{8,9}$/ },
  { code: "+66", flag: "🇹🇭", label: "Thailand", startFormat: "8", phoneLength: 9, phoneRegex: /^[689]\d{8}$/ },
  { code: "+81", flag: "🇯🇵", label: "Japan", startFormat: "0", phoneLength: 10, phoneRegex: /^0\d{9,10}$/ },
  { code: "+49", flag: "🇩🇪", label: "Germany", startFormat: "0", phoneLength: 10, phoneRegex: /^0\d{10}$/ },
  { code: "+33", flag: "🇫🇷", label: "France", startFormat: "6", phoneLength: 10, phoneRegex: /^0[67]\d{8}$/ },
];


export default countryCodes;
